import { Component, OnInit, Input, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { HandleUploadService } from 'src/app/shared/modules/shared/services/handle-upload.service';
import { NotificationService } from 'src/app/services/notification.service';
import { ResourceService } from 'src/app/services/resources/resource.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Observable, of } from 'rxjs';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-single-file-upload',
  templateUrl: './single-file-upload.component.html',
  styleUrls: ['./single-file-upload.component.scss']
})
export class SingleFileUploadComponent implements OnInit {

  @Input() fieldLabelName: string = '';
  @Input() moduleName: string = '';
  @Input() fieldControlName: string = '';
  @Input() isRequiredField: boolean = false;
  @Input() fieldHeading: string = '';
  @Input() fieldSubHeading: string = '';
  @Input() fieldExtensions: string = '';
  @Input() minWidth: any = 0;
  @Input() minHeight: any = 0;
  @Input() maxSize: any = 0;

  @Input() document_path: string = '';

  submitFormSub!: Subscription;
  formSubmitStatus: boolean = false;
  formData!: any;

  //FOR FILE UPLOAD PROGRESS STATUS
  multiFilesData: any[] = [];
  uploadedFilesData: any[] = [];

  //FOR EDIT FORM
  sharedDataSub!: Subscription;
  editData: any = null;

  //FOR DELETE CONFIRM POPUP
  deleteModalRef: any = null;
  @ViewChild('deleteModal', { static: false }) deleteModal!: ElementRef;
  deleteMessage: string = '';
  deleteInfo: any = null;
  @Input() allowedFileTypes: any[] = ['image/', 'video/', 'audio/', 'doc/', 'application/', 'text/'];

  @Output() sendFieldStatus: EventEmitter<any> = new EventEmitter<any>();

  constructor(private notificationService: NotificationService, private handleUploadService: HandleUploadService, private resourceService: ResourceService, private fb: FormBuilder, private modalService: NgbModal) { }

  ngOnInit() {

    this.submitFormSub = this.handleUploadService.submitFormStatus.subscribe((data: any) => {
      this.formData = this.handleUploadService.addForm;
      this.formSubmitStatus = data.formSubmitStatus;
    });

    this.sharedDataSub = this.handleUploadService.getSharedData.subscribe((data: any) => {
      this.editData = data.editData;
      //FOR EDIT FORM
      this.setEditFormResource();
    });
  }

  ngAfterViewInit() {
    this.formData = this.handleUploadService.addForm;
  }

  resetFileField(event) {
    if (event.target) {
      event.target.value = '';
    }
  }

  onFileDropped(event) {
    let files = event.files;
    this.uploadMultiResource(files, event);
  }

  onSelectFiles(event) {
    let files = event.target.files;
    this.uploadMultiResource(files, event);
  }

  uploadMultiResource(files, event) {
    if (this.handleUploadService.addForm.controls[this.fieldControlName].value != '') {
      this.resetFileField(event);
      this.notificationService.showNotification('info', 'Please remove previous uploaded file.');
      return;
    }

    if (files.length > 1) {
      this.resetFileField(event);
      this.notificationService.showNotification('info', 'Please provide only one file.');
      return false;
    }

    if (!this.validateFiles(files)) {
      this.resetFileField(event);
      return false;
    }

    if(this.fieldExtensions == 'image/*') {
      this.validateWidthHeight(files);
    }
    else {
      //UPLOAD FILES
      this.multiFilesData = [];
      for (let i = 0; i < files.length; i++) {
        this.uploadSingleResource(i, files[i], 'file');
      }
    }
  }

  validateFiles(files) {
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (!this.validateFileType(file)) {
        return false;
      }

      //COMMENTED TO SUPPORT MAX FILE SIZE
      /*if (!this.validateFileSize(file)) {
        return false;
      }*/
    }

    return true;
  }

  validateFileType(file) {
    const fileType = file.type;
    if(this.fieldExtensions == 'image/*') {
      const allowedFileType = 'image/';
      if (fileType.indexOf(allowedFileType) == -1) {
        this.notificationService.showNotification('info', 'Only image file is allowed.');
        return false;
      }
    }
    else {
      const allowedFileType = this.allowedFileTypes;
      let checkFileType = fileType.split('/')[0]+'/'
      if (allowedFileType.indexOf(checkFileType) == -1) {
        this.notificationService.showNotification('info', 'Only image, video, audio, pdf & text file is allowed.');
        return false;
      }
    }

    return true;
  }

  validateFileSize(file) {
    let fileSize = ((file.size / 1024) / 1024);
    if (fileSize > this.maxSize) {
      const fileErr = "Maximum file size allowed for upload: " + this.maxSize + ' MB';
      this.notificationService.showNotification('info', fileErr);
      return false;
    }

    return true;
  }

  validateWidthHeight(files) {
    const _URL = window.URL;
    for (let i = 0; i < files.length; i++) {
      const that = this;
      const img = new Image();
      let imgWidth = 0;
      let imgHeight = 0;
      img.src = _URL.createObjectURL(files[i]);
      img.onload = function () {
        imgWidth = img.width;
        imgHeight = img.height;

        if ((imgWidth < that.minWidth) || (imgHeight < that.minHeight)) {
          const fileErr = "Image width x height must be greater than: " + that.minWidth + 'PX' + " X " + that.minHeight + "PX";
          that.notificationService.showNotification('info', fileErr);
          that.resetFileField(event);
          return false;
        }

        //UPLOAD FILES
        that.multiFilesData = [];
        for (let i = 0; i < files.length; i++) {
          that.uploadSingleResource(i, files[i], 'file');
        }
      }
    }
  }

  uploadSingleResource(idx, file, type) {
    if (file) {
      const fileName = this.fieldLabelName;
      let progressBar = 0;
      let progressTime = 0;
      let startDate = new Date;

      this.notificationService.upload_resource(this.moduleName, file).subscribe(
        (response: HttpEvent<any>) => {
          switch (response.type) {
            case HttpEventType.Sent:
              break;
            case HttpEventType.ResponseHeader:
              break;
            case HttpEventType.UploadProgress:
              progressBar = Math.round(response.loaded / response.total * 100);

              //TIME CALCULATION
              let currDate = new Date;
              let timeElapsed: number = currDate.getTime() - startDate.getTime();
              let uploadSpeed = response.loaded / (timeElapsed / 1000);
              let seconds = (file.size - response.loaded) / uploadSpeed;
              progressTime = Math.round(seconds);

              this.multiFilesData[idx] = { name: fileName, progressBar: progressBar, progressTime: progressTime, uploadStatus: false };
              break;

            case HttpEventType.Response:
              this.notificationService.showNotification('success', 'File uploaded successfully');
              setTimeout(() => {
                progressBar = 0;
                progressTime = 0;
                this.multiFilesData[idx] = { name: fileName, progressBar: progressBar, progressTime: progressTime, uploadStatus: true };
                this.updateUploadedResources(this.multiFilesData[idx], response);
              }, 1000);
          }
        },
        (err) => {
          progressBar = 0;
          progressTime = 0;
          this.multiFilesData[idx] = { name: fileName, progressBar: progressBar, progressTime: progressTime, uploadStatus: false };
          this.notificationService.showNotification('info', 'Please add again not able to save your file');
        });
    }
  }

  updateUploadedResources(multiFile, response) {
    const resourceData = response.body.resource_info[0];
    const resourcePath = resourceData.path;
    const resourceId = resourceData.resource_id;
    const resourceUrl = resourceData.url;
    let resourceInfo = {
      resource_title: multiFile.name,
      resource_type: 'file',
      resource_id: resourceId,
      resource_url: resourceUrl,
      path: resourcePath,
      resource_deleted: false
    };
    this.uploadedFilesData.unshift(resourceInfo);
    //console.log(this.uploadedFilesData);

    //TO REMOVE RESOURCES
    this.handleUploadService.allUploadedFiles.push(resourcePath);

    //SET DATA INTO FORM FIELD
    this.manageUploadedFiles();
  }

  deleteUploadedResource(uploadedFileIndex) {
    this.openDeleteModal();
    this.deleteMessage = 'Are you sure want to remove this ' + this.fieldLabelName + ' ? ';
    this.deleteInfo = {uploadedFileIndex: uploadedFileIndex};
  }

  //FOR DELETE CONFIRM POPUP
  openDeleteModal() {
    this.deleteModalRef = this.modalService.open(this.deleteModal);
  }

  closeDeleteModal() {
    this.deleteModalRef.close();
    return;
  }

  onConfirmDelete() {
    const uploadedFileIndex = this.deleteInfo.uploadedFileIndex;

    this.uploadedFilesData[uploadedFileIndex].resource_deleted = true;
    this.manageUploadedFiles();

    this.deleteModalRef.close();
    this.deleteInfo = null;

    // send status to parent component
    this.sendFieldStatus.emit({ fileDeleted: true });
  }

  manageUploadedFiles() {
    this.setResourcesFiles();
  }

  setResourcesFiles() {
    this.handleUploadService.addForm.controls[this.fieldControlName].setValue('');

    if (this.uploadedFilesData.length > 0) {
      this.uploadedFilesData.forEach((e, index) => {
        if (!e.resource_deleted) {
          if(this.document_path == '') {
            this.handleUploadService.addForm.controls[this.fieldControlName].setValue(e.resource_id);
          }
          else {
            this.handleUploadService.addForm.controls[this.fieldControlName].setValue(e.resource_id+':::'+e.path);
          }
        }
        else {
          this.handleUploadService.allDeletedFiles.push(e.path);
        }
      });
    }
  }

  //FOR EDIT FORM |START
  setEditFormResource() {
    this.handleUploadService.addForm.controls[this.fieldControlName].setValue('');

    if (this.editData[this.fieldControlName]) {
      this.uploadedFilesData = [];
      this.uploadedFilesData[0] = {};
      this.uploadedFilesData[0].resource_title = this.fieldLabelName;
      this.uploadedFilesData[0].resource_type = 'file';
      this.uploadedFilesData[0].resource_id = this.editData[this.fieldControlName];
      this.uploadedFilesData[0].resource_url = this.editData[this.fieldControlName + '_url'];
      this.uploadedFilesData[0].path = '';
      this.uploadedFilesData[0].resource_deleted = false;
      //SET DATA INTO FORM FIELD
      this.manageUploadedFiles();
    }
  }
  //FOR EDIT FORM |END

  ngOnDestroy() {
    this.submitFormSub.unsubscribe();
    this.sharedDataSub.unsubscribe();
  }

}
